import React from 'react';
import bannersModule, { BannerTypes } from '@gin-betting/banners';
import { GQL } from '@gin-betting/core';

import { Carousel } from 'components';
import ColorfulBanner from '../ColorfulBanner';
import CMSBanner from '../CMSBanner';
import useColorfulBanners from './useColorfulBanners';
import './colorfulBanners.scss';

const {
    hocs: { withAvailableZoneByAttributes },
} = bannersModule;

interface OwnProps {
    zoneLocation: BannerTypes.BannerZoneLocation;
}

type Props = OwnProps & BannerTypes.WithAvailableZoneProps;

const ColorfulBanners: React.FC<Props> = ({ zoneId }) => {
    const { filteredBanners, interval } = useColorfulBanners({ zoneId });

    if (!filteredBanners.length) return null;

    const renderBanners = () =>
        filteredBanners.map(banner => {
            switch (banner.type) {
                case GQL.BannerType.cms_banner: {
                    return (
                        <CMSBanner
                            bannerId={banner.id}
                            key={`${banner.type}-${banner.id}`}
                        />
                    );
                }

                default: {
                    return (
                        <ColorfulBanner
                            key={`${banner.type}-${banner.id}`}
                            banner={banner}
                        />
                    );
                }
            }
        });

    return (
        <div styleName="container">
            <Carousel
                hasControls={true}
                delay={interval}
                direction="left"
                hasLoader={true}
            >
                {renderBanners()}
            </Carousel>
        </div>
    );
};

export default withAvailableZoneByAttributes(ColorfulBanners);
